import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { getAuthToken } from '../utils';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ component, section, ...rest }) => {
  const hasToken = useMemo(() => {
    const token = getAuthToken();
    return !isEmpty(token);
  }, []);

  const { canView } = useAuth();

  const CurrentComponent = component;

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!hasToken) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          );
        }

        if (section && !canView(section)) {
          return <Redirect to="/home" />;
        }

        return <CurrentComponent />;
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  section: PropTypes.string,
};

PrivateRoute.defaultProps = {
  section: null,
};

export default PrivateRoute;
